import React from 'react';
import { BarChart, Bar, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useColorMode } from '../../../../theme/ColorModeProvider';
import { getChartPalette } from '../../../../theme/colorMode';
import { Section, Panel, MetricGrid, HiddenChartTable, EmptyState } from './shared';
import { formatCount, formatDay } from '../utils';
import { useInsightsStyles } from '../styles';

const COLORS = ['#3D7DDD', '#16a34a', '#f59e0b', '#8b5cf6'];

/** `new_this_week`: always the last 7 days, regardless of the period switcher. */
const NewThisWeek = ({ data = {} }) => {
  const classes = useInsightsStyles();
  const chart = getChartPalette(useColorMode().mode);
  const items = data.items || [];
  const days = data.days || [];
  const points = days.map((day, index) => items.reduce(
    (point, item) => ({ ...point, [item.key]: item.per_day?.[index] ?? 0 }),
    { day, label: formatDay(day) },
  ));
  const tiles = items.map(item => ({
    key: item.key,
    label: item.label,
    value: item.value,
    note: `${formatCount(item.previous)} in the 7 days before`,
    description: item.description,
  }));
  return (
    <Section id="new_this_week" title="New this week" subtitle={data.description} exportKey="new_this_week">
      <Panel>
        {items.length ? <MetricGrid items={tiles} columns={4} /> : <EmptyState>{data.description}</EmptyState>}
        {points.length && items.length ? <>
          <div className={classes.chart} role="img" aria-label="Bar chart of records created each day this week">
            <ResponsiveContainer>
              <BarChart data={points} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
                <CartesianGrid stroke={chart.grid} vertical={false} />
                <XAxis dataKey="label" stroke={chart.axis} tick={{ fontSize: 12 }} />
                <YAxis stroke={chart.axis} tick={{ fontSize: 12 }} allowDecimals={false} />
                <Tooltip contentStyle={{ background: chart.tooltipBg, borderColor: chart.tooltipBorder }} formatter={value => formatCount(value)} />
                <Legend wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
                {items.map((item, index) => <Bar key={item.key} dataKey={item.key} name={item.label} fill={COLORS[index % COLORS.length]} radius={[3, 3, 0, 0]} />)}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <HiddenChartTable caption="Records created each day this week" headers={['Day', ...items.map(item => item.label)]} rows={points.map(point => [point.label, ...items.map(item => point[item.key])])} />
        </> : null}
      </Panel>
    </Section>
  );
};

export default NewThisWeek;
